import { useEffect } from "react";
import {
    wasVersionUpdatePromptedToday,
    wasVersionUpdateReloadedRecently,
} from "@/lib/helpers/version-update-helper";

export function useVersionChecker({
    interval = 500000,
    onUpdateAvailable,
}: {
    interval?: number;
    onUpdateAvailable: (version: string) => void;
}) {
    useEffect(() => {
        const currentVersion = __APP_VERSION__;
        console.log("Current version:", currentVersion);

        const check = async () => {
            try {
                const res = await fetch("/version.json", { cache: "no-cache" });
                const data = await res.json();
                if (
                    data.version !== currentVersion &&
                    !wasVersionUpdateReloadedRecently() &&
                    !wasVersionUpdatePromptedToday(data.version)
                ) {
                    onUpdateAvailable(data.version);
                }
            } catch (err) {
                console.error("Version check failed", err);
            }
        };

        const id = setInterval(check, interval);
        return () => clearInterval(id);
    }, [interval, onUpdateAvailable]);
}
